module.exports = __webpack_public_path__ + "static/media/icon-menu-services-active.2bcef560.svg";